// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';

// Interne Module
import * as storage from '@/_helper/storage';
import { buildPostRequest } from '@/_helper/apiHelper';

// Komponenten
import '@/comp/button/button.scss';
import { Icon } from '@/comp/icon/icon.tsx';

class AddParticipants extends Component {
    constructor(props) {
        super(props);

        this.state = {
            supplierOfferId: props.supplierOfferId !== undefined ? props.supplierOfferId : null,
            active: false,
            isValid: false,
        };
        this.getParticipants = this.getParticipants.bind(this);
        this.getHandleShowAddParticipants = this.getHandleShowAddParticipants.bind(this);
    }

    componentDidMount() {
        this.getParticipants();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.handleShowAddParticipants() !== this.state.active) {
            this.getHandleShowAddParticipants();
        }
    }

    getHandleShowAddParticipants() {
        if (this.props.handleShowAddParticipants() !== this.state.active) {
            this.setState({
                active: this.props.handleShowAddParticipants(),
            });
        }
    }

    getParticipants() {
        let $this = this;
        let bookingData = storage.get('bookingData');

        function setParticipants(travellers) {
            if (travellers !== undefined) {
                _.forEach(travellers, function (v, k) {
                    _.assign(v, {
                        checked: false,
                        index: k,
                    });
                });

                $this.setState({ ...$this.state, participants: travellers });
            }
        }

        if (bookingData !== null && bookingData.bookingParams?.travellers !== null) {
            let travellers = bookingData.bookingParams?.travellers;
            setParticipants(travellers);
        }

        if (bookingData.bookingParams?.travellers === undefined) {
            if (storage.get('access_token') !== null) {
                const loginData = {
                    requestType: 'bookingData',
                    bookingId: storage.get('bookingNumber'),
                    action: 'getBookingParams',
                    clientId: 'customerarea',
                    requestSource: 'AurumTours-Customerarea',
                    hash: storage.get('access_token'),
                };

                axios(buildPostRequest(window.$serviceUrl, '/bookingData', loginData))
                    .then((response) => response)
                    .then((data) => {
                        let response = data.data.data.data;

                        if (response !== null) {
                            let travellers = response?.travellers;
                            setParticipants(travellers);

                            // save bookingParams
                            let bookingData = _.assign(storage.get('bookingData'), {
                                bookingParams: response,
                            });

                            storage.set('bookingData', bookingData);
                        }
                    })
                    .catch((error) => this.setState({ error }));
            }
        }
    }

    ratesLink() {
        let baseLink = '#/ausfluege/rates/';

        let participants = [];
        _.forEach(_.filter(this.state.participants, { checked: true }), function (value) {
            participants.push(value.index);
        });

        return baseLink + this.state.supplierOfferId + '/?p=' + participants.toString();
    }

    handleChange(event) {
        const item = event.target.name;
        const index = item.match(/\d/g)[0];

        let participants = this.state.participants;
        participants[index].checked = event.target.checked;

        this.setState(
            {
                participants: participants,
            },
            this.valid
        );
    }

    valid(event) {
        let c = _.filter(this.state.participants, { checked: true }),
            hasError = false,
            isValid = true,
            errorAdult = false;

        if (c.length === 0) {
            hasError = true;
            isValid = false;
        } else {
            if (event && event.target.classList.contains('button')) {
                errorAdult = true;
                isValid = false;
                c.forEach((item) => {
                    if (item.participantType === 'adult') {
                        errorAdult = false;
                        isValid = true;
                    }
                });
            } else {
                hasError = false;
                isValid = true;
            }
        }

        this.setState({ ...this.state, error: hasError, errorAdult: errorAdult, isValid: isValid });
    }

    adults() {
        let travellers = this.state.participants;
        // fake
        // travellers[1].dateOfBirth = new Date ('2010-09-14');

        let getAdults = _.filter(travellers, function (o) {
            let birthDate = new Date(o.dateOfBirth);

            let year = new Date(Date.now() - birthDate.getTime()).getUTCFullYear();

            let age = Math.abs(year - 1970);

            return age >= 13;
        });

        const items = [];

        if (Object.keys(getAdults).length > 0) {
            Object.keys(getAdults).forEach((k) => {
                const { foreName, surName, index } = getAdults[k];

                items.push(
                    <label key={index} className="entry">
                        <span>
                            {foreName} {surName}
                        </span>
                        <input
                            type="checkbox"
                            name={'participants[' + index + ']'}
                            onChange={(event) => this.handleChange(event)}
                        />
                        <span className="checkbox-trigger"></span>
                    </label>
                );
            });

            return (
                <div className="adults">
                    <h3 className="title">Erwachsene</h3>
                    {items}
                </div>
            );
        }
    }

    childs() {
        let travellers = this.state.participants;

        let getChilds = _.filter(travellers, function (o) {
            let birthDate = new Date(o.dateOfBirth);

            let year = new Date(Date.now() - birthDate.getTime()).getUTCFullYear();

            let age = Math.abs(year - 1970);

            return age <= 13;
        });
        const items = [];

        if (Object.keys(getChilds).length > 0) {
            Object.keys(getChilds).forEach((k) => {
                const { foreName, surName, index } = getChilds[k];

                items.push(
                    <label key={index} className="entry">
                        <span>
                            {foreName} {surName}
                        </span>
                        <input
                            type="checkbox"
                            name={'participants[' + index + ']'}
                            onChange={(event) => this.handleChange(event)}
                        />
                        <span className="checkbox-trigger"></span>
                    </label>
                );
            });

            return (
                <div className="childs">
                    <h3 className="title">Kinder</h3>
                    {this.state.errorAdult && (
                        <div className="error">
                            Kinder müssen mindestens von einem Erwachsenen begleitet werden, um an einem Ausflug
                            teilnehmen zu können.
                        </div>
                    )}
                    {items}
                </div>
            );
        }
    }

    render() {
        let { participants, active } = this.state;

        if (participants === undefined) {
            return false;
        }
        let count = Object.keys(participants).length;

        return (
            <>
                {active && (
                    <div className={'add-participants link' + (this.state.active ? ' show' : ' ')}>
                        <div className="cnt">
                            <div
                                className="close"
                                role="button"
                                aria-label="schließen"
                                onClick={() => {
                                    this.props.handleShowAddParticipants(false);
                                    this.setState({
                                        ...this.state,
                                        error: false,
                                    });
                                }}>
                                <Icon name="close" ariaHidden />
                            </div>

                            <h3 className="heading">
                                Teilnehmende {window.$browserInfo.device === 'mobile' && <br />} hinzufügen
                            </h3>
                            <p>Welche Personen (von {count} Reiseteilnehmern) werden am Ausflug teilnehmen?</p>

                            <div className="content">
                                {this.adults()}
                                {this.childs()}
                            </div>

                            {this.state.error && (
                                <div className="error">Bitte wählen Sie mind. ein Teilnehmer aus.</div>
                            )}

                            <div className="call-action">
                                <p>Preise und Datum werden Ihnen im nächsten Schritt angezeigt.</p>

                                <a
                                    className={'button-element link' + (!this.state.isValid ? ' deactive' : ' ')}
                                    href={this.state.isValid ? this.ratesLink() : null}
                                    onClick={(event) => this.valid(event)}>
                                    weiter
                                </a>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default AddParticipants;
